import React, {ChangeEvent, FC, HTMLAttributes, useState} from 'react';
import css from "./Comment.module.scss";
import TextArea from "antd/es/input/TextArea";
import Button from "../../../../elements/Button/Button";
import classNames from 'classnames/bind';
import {Contact} from "../../interfaces/Contact";
import $api from "../../../../http";
import {useNavigate} from "react-router-dom";
import {SubscriptionSettingsTranslation} from "../../interfaces/SubscriptionSettingsTranslation";
import {RouteNames} from "../../../../router";
import {useQuery} from "../../../../hooks/useQuery";

const cx = classNames.bind(css);

interface CommentProps extends HTMLAttributes<HTMLDivElement> {
    contact: Contact,
    localization: SubscriptionSettingsTranslation,
}

const Comment: FC<CommentProps> = ({contact, localization, className}) => {
    const [value, setValue] = useState<string>('');
    const navigate = useNavigate();
    const messageId = useQuery('messageId');

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setValue(e.target.value);
    }


    const sendComment = async () => {
        if (value.length > 2) {
            const result = await $api.post('/api/Subscription/UnsubscribeUpdate', {
                deletedOn: contact.deletedOn,
                id: contact.id,
                countryCode: contact.countryCode,
                language: contact.language,
                name: contact.name,
                status: contact.status,
                cancelledSubscriptions: contact.cancelledSubscriptions.map(c => ({...c, comment: value}))
            })

            if (result.status === 200) {
                navigate(RouteNames.SUBSCRIPTION_THANKS + '?messageId=' + messageId, {
                    state: {
                        localization,
                        countryCode: contact.countryCode,
                    }
                })
            }
        }
        setValue('');
    }


    return (
        <section className={cx(css.main, className)}>
            <h2 className={css.main__title}>
                {localization.CommentYourChosen}
            </h2>
            <p className={css.main__subTitle}>
                {localization.HelpUsBeBetter}
            </p>
            <TextArea value={value} onChange={handleChange} className={css.main__comment}
                      placeholder={localization.EnterText} rows={6}/>
            <Button onClick={sendComment} className={css.main__btn}>{localization.SendComment}</Button>
        </section>
    );
};

export default Comment;